import React from 'react';

import { getConfig, getTranslation } from '../../utils/config';
import { useDfContext } from '../../context/df-context';
import { UPDATE_TOAST } from '../../context/actions';

import { getShareLink } from './get-share-link';
import type { IProps } from './types';

export default function Share({ type, group, item }: IProps): React.ReactElement {
  const { dispatch } = useDfContext();

  const copyTextToClipboard = async () => {
    try {
      const shareLink = getShareLink(type, group, item);

      await navigator.clipboard.writeText(shareLink);

      dispatch({
        type: UPDATE_TOAST,
        showToast: true,
        message: getTranslation('share_success'),
      });
    } catch (e) {
      dispatch({
        type: UPDATE_TOAST,
        showToast: true,
        message: getTranslation('share_error'),
      });
    }
  };

  return (
    <button
      className="df-icon-btn"
      title={getTranslation('share_button')}
      onClick={copyTextToClipboard}
      aria-label={getTranslation('share_button')}
    >
      <svg className="df-action-icon">
        <use href={getConfig('material_symbols_url') + '#content_copy_400'} />
      </svg>
    </button>
  );
}
